import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=bad51afc&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"
import style0 from "./PostForm.vue?vue&type=style&index=0&id=bad51afc&prod&scoped=true&lang=css"
import style1 from "./PostForm.vue?vue&type=style&index=1&id=bad51afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad51afc",
  null
  
)

export default component.exports